import { ClassRequestModel, CommonResponse, CreateQuestionBankReqModel, LatestNewQuestionsResponse, LatestQuestionBankResponse, QNPIdReq, QuestionBankResponse, QuestionBankViewReq, SubjectClassReqModel } from "@boi/shared-models";
import { AxiosRequestConfig } from "axios";
import { CommonAxiosService } from "../common-axios-service";
import { assignAndGetLoaingReqStatusForHeaders as assignAndGetLoadingReqStatusForHeaders } from "../loading-helper";

export class CreateQuestionBankService extends CommonAxiosService {

    private getURLwithMainEndPoint(childUrl: string) {
        return '/createQuestionBank/' + childUrl;
    }

    async createQuestionBank(req: CreateQuestionBankReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('createQuestionBank'), req, config);
    }
    
    async updateQuestionBank(req: any, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('updateQuestionBank'), req, config);
    }

    async getQuestionById(id: number, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint(`/getQuestionById/${id}`), config);
    }

    async getAllQuestionBankData(req: QuestionBankViewReq, config?: AxiosRequestConfig): Promise<QuestionBankResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllQuestionBankData'), req, config)
    }

    async GetSingleQuestionBankData(req: QuestionBankViewReq, config?: AxiosRequestConfig): Promise<LatestNewQuestionsResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('GetSingleQuestionBankData'), req, config)
    }

    async getAllLatestQuestionBankData(req: QuestionBankViewReq, config?: AxiosRequestConfig): Promise<LatestQuestionBankResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllLatestQuestionBankData'), req, config)
    }

    async activateOrDeactivateQuestion(req: QNPIdReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('activateOrDeactivateQuestion'), req, config)
    }

    async activateOrDeactivateLatestQuestion(req: QNPIdReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('activateOrDeactivateLatestQuestion'), req, config)
    }

    async getQuestionsCountSummery(req: ClassRequestModel, hideLoadingSymbol?: boolean, config?: AxiosRequestConfig): Promise<CommonResponse> {
        const modifiedConfig = assignAndGetLoadingReqStatusForHeaders(hideLoadingSymbol, config);
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getQuestionsCountSummery'), req, modifiedConfig)
    }

    async getQuestionSubjectPivot(req: ClassRequestModel, hideLoadingSymbol?: boolean, config?: AxiosRequestConfig): Promise<CommonResponse> {
        const modifiedConfig = assignAndGetLoadingReqStatusForHeaders(hideLoadingSymbol, config);
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getQuestionSubjectPivot'), req, modifiedConfig)
    }

    async getAllCollegeCodesAndSymbols(config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllCollegeCodesAndSymbols'), config)
    }

    async getAllQuestionsCountsBySubject(req: SubjectClassReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllQuestionsCountsBySubject'), req, config)
    }
}
